/*
 * Copyright © 2023 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcTooltipComponent } from './fc-tooltip.component';
import { FcTooltipDirective } from './fc-tooltip.directive';

/**
 * FcTooltip module with Angular.
 */
@NgModule({
    declarations: [
        FcTooltipComponent,
        FcTooltipDirective
    ],
    imports: [ CommonModule ],
    exports: [
        FcTooltipComponent,
        FcTooltipDirective
    ]
})
export class FcTooltipModule { }